<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopConfig.basicSettings') }}</div>
        <div class="ibox-tools" style="top:10px;">
          <el-button type="primary" size="small" @click="openEditShopConfigInfoModel">
            {{ $t('shopConfig.edit') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-row>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('shopConfig.businessStartTime') }}</label>
              <label>{{ shopConfigInfo.ostartTime }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('shopConfig.businessEndTime') }}</label>
              <label>{{ shopConfigInfo.oendTime }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('shopConfig.deliveryMethod') }}</label>
              <label>{{ shopConfigInfo.sendWay == 'SHOP' ? $t('shopConfig.selfDelivery') :
                $t('shopConfig.storeVerification') }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('shopConfig.deliveryFee') }}</label>
              <label>{{ shopConfigInfo.sendFee }}</label>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <div class="">
      <shop-config-sms ref="shopConfigSms"></shop-config-sms>
    </div>

    <edit-shop-config ref="editShopConfig" @refresh="loadShopConfigInfoData()"></edit-shop-config>

  </div>
</template>

<script>
import { getShopConfigList } from '@/api/shop/shopConfigApi'
import ShopConfigSms from '@/components/shop/shopConfigSms/shopConfigSms.vue'
import EditShopConfig from '@/components/shop/editShopConfig/editShopConfig.vue'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopConfig',
  components: {
    ShopConfigSms,
    EditShopConfig
  },
  data() {
    return {
      shopConfigInfo: {
        shopId: '',
        ostartTime: '',
        oendTime: '',
        sendWay: '',
        sendFee: ''
      }
    }
  },
  created() {
    this.loadShopConfigInfoData()
  },
  methods: {
    openEditShopConfigInfoModel() {
      this.$refs.editShopConfig.open(this.shopConfigInfo)
    },
    loadShopConfigInfoData() {
      const params = {
        page: 1,
        row: 1,
        shopId: getShopId()
      }

      getShopConfigList(params).then(res => {
        if (res.data && res.data.length > 0) {
          this.shopConfigInfo = { ...res.data[0] }
        }
      }).catch(error => {
        console.error('请求失败:', error)
      })
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 1px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}

.form-group {
  margin-bottom: 15px;
}

.col-form-label {
  margin-bottom: 5px;
}

.margin-top-sm {
  margin-top: 10px;
}
</style>